module.exports = __webpack_public_path__ + "img/20201107_204213.ff8c075b.jpg";